export class RefUnite {
    static jsonMap = {
        id: 'idUnite',
        code: 'codeUnite',
        libelle: 'libelleUnite'
    };

    id: number = undefined;
    code: string = undefined;
    libelle: string = undefined;
}
